export const SITE_SECTION = {
  APPLICATION_FORM: 'application-form',
  QUOTE_FORM: 'quote-form'
};

export const PAGE_TYPE = 'grid-f-editable-template';
export const CONTENT_CATEGORY = 'travel';

export const EVENT = {
  PAGE_LOAD: 'pageLoad',
  QUOTE_START: 'quoteStart',
  FORM_STEP: 'formStep',
  QUOTE_COMPLETE: 'quoteComplete',
  APP_START: 'appStart',
  transaction_start: 'transaction_start'
};

export const ADOBE_DATALAYER_EVENT = {
  PAGE_LOAD: 'page_load',
  TRANSACTION_START: 'transaction_start',
  TRANSACTION_STEP: 'transaction_step',
  TRANSACTION_COMPLETE: 'transaction_complete',
  LINK_CLICK: 'link_click'
};

export const FORM_FIELD = {
  GET_QOUTE: 'get-quote',
  SUBMIT_APPLICATION: 'submit-application',
  APPLY: 'Apply',
  TYPE: 'transaction'
};

export const FORM_STEP = {
  QUOTE_START: 'quoteStart',
  QUOTE_STEP1: 'quoteStep1',
  QUOTE_STEP2: 'quoteStep2',
  QUOTE_COMPLETE: 'quoteComplete',
  APPLICATION_START: 'applicationStart',
  APPLICATION_STEP1: 'applicationStep1',
  APPLICATION_STEP2: 'applicationStep2',
  APPLICATION_COMPLETE: 'applicationComplete'
};

export const TRANSACTION_VALUE = {
  tripDetails: 'Trip details',
  travellerDetails: 'Traveller details',
  planSelection: 'Plan selection',
  quoteSummary: 'Quote summary',
  contactDetails: 'Contact Details',
  payment: 'Review details and payment',
  confirmation: 'Purchase confirmation'
};

export const TRANSACTION_STEP = {
  start: 'Start',
  step2: 'Step2',
  step3: 'Step3',
  step4: 'Step4',
  step5: 'Step5',
  step6: 'Step6',
  step7: 'Step7'
};

export const LinkName = {
  saveQuote: 'Submit save a quote',
  enrollTraveller: 'Enroll the traveller(s)',
  enrollTravellerSubmit: 'Submit Enroll the traveller(s)'
};
